require('client/main-components-dispatcher.js');
